import {
    Directive,
    ComponentRef,
    ViewContainerRef,
    ComponentFactoryResolver,
    Inject,
    AfterViewInit,
    ContentChild,
    ElementRef,
    Renderer2,
    Host,
    Optional,
    ComponentFactory
} from '@angular/core';
import { ControlErrorComponent } from '../../components/control-error/control-error.component';
import { Observable, EMPTY, merge } from 'rxjs';
import { FORM_ERRORS } from './form-errors';
import { MatLegacyFormField as MatFormField } from '@angular/material/legacy-form-field';
import { FormSubmitDirective } from './form-submit.directive';
import { ValidationErrors, NgControl, AbstractControlDirective } from '@angular/forms';

@Directive({
    selector: '[rsControlError]'
})
export class ControlErrorsDirective implements AfterViewInit {
    public ref!: ComponentRef<ControlErrorComponent>;
    public submit$: Observable<Event>;

    @ContentChild('field', { read: ElementRef }) public controlElementRef!: ElementRef;

    public constructor(
        @Inject(FORM_ERRORS) private errors: any,
        @Optional() @Host() private form: FormSubmitDirective,
        private container: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private renderer: Renderer2,
        private formField: MatFormField
    ) {
        this.submit$ = this.form ? this.form.submit$ : EMPTY;
    }

    public ngAfterViewInit(): void {
        if (this.control === null || this.control?.valueChanges === null) {
            return;
        }
        this.renderer.listen(this.controlElementRef.nativeElement, 'blur', (): void => {
            this.onChange();
        });
        merge(this.submit$, this.control.valueChanges).subscribe((): void => {
            this.onChange();
        });
    }

    private onChange(): void {
        const controlErrors: ValidationErrors | null | undefined = this.control?.errors;
        if (controlErrors) {
            const firstKey: string = Object.keys(controlErrors)[0];
            let text: string = '';
            if (firstKey === undefined) {
                return;
            }
            if (firstKey === 'forbiddenName') {
                text = controlErrors.forbiddenName;
            } else {
                const getError: any = this.errors[firstKey];
                if (typeof getError !== 'function') {
                    console.error('onChange / this.errors', this.errors);
                }
                text = getError(controlErrors[firstKey]);
            }
            this.formField.color = 'warn';
            this.setError(text);
            // @todo is not possible exit from input when is dirty
            // this.controlElementRef.nativeElement.focus();
        } else if (this.ref) {
            this.formField.color = 'primary';
            this.setError(null);
        }
    }

    public get control(): NgControl | AbstractControlDirective | null {
        return this.formField._control.ngControl;
    }

    // I use any because this.ref.instance.text can get null too
    public setError(text: any): void {
        if (!this.ref) {
            const factory: ComponentFactory<ControlErrorComponent> = this.resolver.resolveComponentFactory(ControlErrorComponent);
            this.ref = this.container.createComponent(factory);
        }
        this.ref.instance.text = text;
    }
}
